import type { ReactNode } from 'react';

interface PreviewFrameProps {
  children: ReactNode;
}

/**
 * The small white box every miniature is drawn in. Content is laid out at twice
 * its final size and zoomed to half, so a miniature can use the very same
 * Tailwind classes as the real screen (a 4px border stays a 2px border) and
 * still fit a tile.
 */
export function PreviewFrame({ children }: PreviewFrameProps) {
  return (
    <div
      aria-hidden="true"
      data-testid="setting-preview"
      className="pointer-events-none select-none overflow-hidden rounded-sm border border-gray-200 bg-white"
    >
      <div className="[zoom:0.5]">{children}</div>
    </div>
  );
}
